var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('span',[_vm._v("© 2020 ‐ Toni Michael Sattler")]),_c('router-link',{attrs:{"to":{ name: 'LegalInformation' }}},[_vm._v("Impressum & Datenschutz")]),_c('ContactButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }